import { DotsIndicator } from '@workspace/ui/common';

interface ProductCarouselDotsProps {
  snapCount: number;
  selectedIndex: number;
  onDotClick: (index: number) => void;
  className?: string;
}

export function ProductCarouselDots({ snapCount, selectedIndex, onDotClick, className }: ProductCarouselDotsProps) {
  if (snapCount <= 1) return null;

  return <DotsIndicator className={className} count={snapCount} currentIndex={selectedIndex} onDotClick={onDotClick} />;
}
